import React from "react";
import SectionTitle from "../components/SectionTitle";
import InfoData from "../InfoData";
import SectionWrapper from "../components/SectionWrapper";
import Card from "../components/Card";
import animateCSS from "../assets/js/animatecss";
import { useInView } from "react-intersection-observer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const experience = InfoData.experience;

const Experience = () => {

    const ExperienceItem = ({itemInfo, isOdd}) => {
        const {ref} = useInView({
            onChange: setInView,
        });

        const period = itemInfo.period_start + ' - ' + itemInfo.period_end;
        return (
            <div ref={ref}>
                <Card classes={`p-8 mb-8 ${isOdd ? "border-primary" : "border-secondary"}`}>
                    <div className={`flex justify-between items-center flex-wrap-reverse gap-2 ${isOdd ? 'text-primary' : 'text-secondary'}`}>
                        <div className="text-xl font-bold">{itemInfo.title}</div>
                        <div className={`ml-auto border-2 border-solid rounded py-1 px-7 ${isOdd ? 'border-primary' : 'border-secondary'}`}>{period}</div>
                    </div>
                    <div>{itemInfo.company}</div>
                    <div className="flex gap-2 items-center">
                        <span>
                            <FontAwesomeIcon icon={['fas', 'location-dot']}/>
                        </span>
                        <span>
                            {itemInfo.location}
                        </span>
                    </div>
                    <div>
                        <ul className="p-4 list-disc">
                            {
                                itemInfo.description.map((descriptionItem, index) => (
                                    <li key={index}>{descriptionItem}</li>
                                ))
                            }
                        </ul>
                    </div>
                </Card>
            </div>
        );
    }

    const ExperienceContent = () => {
        return (
            <div className="mt-8">
                {
                    experience.map((itemInfo, index) => (
                        <ExperienceItem 
                            key={index} 
                            itemInfo={itemInfo} 
                            isOdd={index % 2 === 0}
                        />
                    ))
                }
            </div>
        );
    }

    const setInView = (inView, entry) => {
        if (inView) {
            animateCSS(entry.target, 'bounceInLeft');
            entry.target.classList.remove('invisible');
        } else {
            entry.target.classList.add('invisible');
        }
    }

    return (
        <SectionWrapper id="experience">
            <SectionTitle title="Experience"/>
            <ExperienceContent/>
        </SectionWrapper>
    );
};

export default Experience;